import { Button } from "@capacit-com/lara-law-shared-ui";
import { cn } from "@/lib/utils";
import { Plus, RotateCcw, Save } from "lucide-react";
import { FieldArrayWithId, UseFormReturn } from "react-hook-form";
import { FormValues } from "../MetadataTypesView";

type MetadataFormFooterProps = {
  addNewMetadataType: () => void;
  fields: FieldArrayWithId<FormValues, "metadataTypes", "id">[];
  form: UseFormReturn<FormValues>;
  hasChanges: boolean;
  handleReset: () => void;
  onSaveClick: () => void;
};

const MetadataFormFooter = ({
  addNewMetadataType,
  fields,
  form,
  hasChanges,
  handleReset,
  onSaveClick,
}: MetadataFormFooterProps) => {
  const handleSaveClick = () => {
    // Trigger validation for all fields
    form.trigger().then((isValid) => {
      if (isValid) {
        onSaveClick();
      }
      // If not valid, the individual field errors will be displayed automatically
    });
  };

  return (
    <div className="flex items-center gap-2 px-2">
      <Button type="button" onClick={addNewMetadataType}>
        <Plus className="w-4 h-4 mr-2" />
        Tilføj metadata
      </Button>
      {(fields.length > 0 || hasChanges) && (
        <Button
          type="button"
          onClick={handleSaveClick}
          disabled={form.formState.isSubmitting || !hasChanges}
          className="disabled:pointer-events-auto disabled:cursor-not-allowed disabled:hover:bg-primary"
        >
          <Save className="w-4 h-4 mr-2" />
          {form.formState.isSubmitting ? "Gemmer..." : "Gem"}
        </Button>
      )}
      <div className={cn(!hasChanges && "cursor-not-allowed")}>
        <Button
          type="button"
          variant="outline"
          onClick={handleReset}
          disabled={!hasChanges}
        >
          <RotateCcw className="w-4 h-4 mr-2" />
          Nulstil alle ændringer
        </Button>
      </div>
    </div>
  );
};

export default MetadataFormFooter;
